import ValidatedForm from "@/validation/ValidatedForm";
import Rpc from "@/Rpc"
import FormValidatedField from "@/components/forms/FormValidatedField";
import RpcInputValidationException from "@/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException";
import Log from "@/utils/Log";
import yaml from "js-yaml"

import TemporaryList from "@/components/forms/TemporaryList"
import RpcClass, {classMap} from "@/server/RpcClass";
import ComplexNewRecord from "@/server/com/silkplm/rpc/dto/ComplexNewRecord";
import InputValidationResult from "@/server/com/silkplm/engine/rpc/validators/InputValidationResult";
import TemporaryExtension from "@/components/forms/TemporaryExtension";
import RtModule from "@/utils/RtModule";
import {
    checkIfEnabledByFeatureFlags,
    findEditEnabledFormBySecuredFields, findFieldValueFromCompanyCompanyConfigurationFormField
} from "@/components/forms/customizations/plm/EntityEditFormService";
import FormsLoader from "@/components/forms/FormsLoader";
import Regions from "@/server/com/silkplm/rpc/Regions";
import * as EntityEditFormService from "@/components/forms/customizations/plm/EntityEditFormService";
import DecimalFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/DecimalFormFieldConfig";
import {
    detectDBLanguage,
    detectInputTypingLanguage,
    fillMissingTranslationsBeforeSaveToDb,
    flatTranslationsBeforeRecordSave
} from "@/utils/TranslationDispatcher";
import {cloneClassInstance, stringifyForCompare} from "@/utils/Objects";
import ApplicationUserOnProductInSeason from "@/server/com/silkplm/model/plm/ApplicationUserOnProductInSeason";

let temporaryId = -1;

let sequence = 1;

export function getTemporaryId() {
    return temporaryId;
}

export default class FormModel extends ValidatedForm {
    constructor(/** FormConfig */ formConfig, presetFields = null) {
        super();

        /** @type { {string:TemporaryList} } */
        this.temporaryLists = {};

        /** @type { {string:TemporaryExtension} } */
        this.temporaryExtensions = {};
        this.openFromGrid = false
        this.temporaryListsErrors = false;
        this.afterSaveStatus = "NEW";
        this.currentAfterSaveStatus = "NEW";
        this.afterSaveChecksum = "";
        this.readOnlyMode = false;

        /**
         * @type {FormModel}
         */
        this.masterFormModel = null;

        /**
         * @type {{string:FormModel}}
         */
        this.childrenFormModels = {};

        /** @type {TemporaryList|null } */
        this.masterTemporaryList = null;

        /** @type {TemporaryExtension|null } */
        this.masterTemporaryExtension = null;

        /** @type {FormConfig} */
        this.formConfig = formConfig;

        /** @type {FormValidatedField[]} */
        this.validatedFields = [];

        /** @type {Map<String, FormValidatedField>} */
        this.validatedFieldsByName = new Map();

        /** @type {Object<FormValidatedField>}} */
        this.fields = {};

        /** @type {FormDetailsConfig} */
        this.detailsConfig = null;

        /** @type {FormExtensionConfig} */
        this.extensionConfig = null;

        /** @type {FormConfig} */
        this.masterFormConfig = null;

        /** @type {FormModel} */
        this.directParentFormModel = null;

        /** @type {String} */
        this.masterId = null;

        this.regionCode = 'def';

        this.afterChangeHandlers = [];
        // TODO odświeżanie zakładek na watch klasach
        // this.externalValidatorHandlers = [];

        this.contextData = {};

        this.detailsNotifications = new Set();
        this.fieldToDetails = new Map();
        this.fieldToDetailsValues = new Map();

        this.extensionModels = new Map();

        /**
         * @param masterInstance {RpcClass}
         * @param fieldName {string}
         * @param validatedField {FormValidatedField}
         * @param detailConf {FormDetailsConfig}
         */
        this.detailReloadCallback = function (masterInstance, fieldName, validatedField, detailConf) {
        };

        this.presetFields = presetFields;

        this.setupFieldsObservers();
        this.setupShadowFieldsObservers();


        this.saveError = "";

        this.checkingUniq = "";
        this.uniqCheckInProgress = false;
        this.uniqCheckPromise = null;
        this.promiseResolve = null;
        this.promiseReject = null;

        this.permissions = null;
        this.effectivePermissionWrite = null;
        this.effectivePermissionRead = null;
        this.restrictedWrite = null;

        this.tag = "frm-" + sequence++;
    }

    destroy() {
        this.detailReloadCallback = null;
        this.onChangeCallback = null;

        this.onChangeHandlers = [];
        this.onChangePreValidateHandlers = [];
        this.onLoadedHandlers = [];
        this.uniqCheckPromise = null;
        this.promiseResolve = null;
        this.promiseReject = null;

        this.permissions = null;
        this.effectivePermissionWrite = null;
        this.effectivePermissionRead = null;
        this.restrictedWrite = null;
        this.canSubmitMonitor = null;
    }


    async setRegion(regionCode) {
        if (!this.originalSource._translations) {
            this.originalSource._translations = {};
        }
        if (!this.originalSource._translations[regionCode]) {
            this.originalSource._translations[regionCode] = {};
        }
        this._forEachValidatedField((name, field) => {
            let translationsEnabled = findFieldValueFromCompanyCompanyConfigurationFormField(this.formConfig,
                field.formFieldConfig, "translations");
            if (translationsEnabled) {
                field.setRegion(regionCode);
            }
        });

        this.collectInputs();
        this.regionCode = regionCode;
        await this.refreshComputedValidatedFields(true);

    }

    afterSave(callback) {
        this.afterChangeHandlers.push(callback);
    }

    // TODO odświeżanie zakładek na watch klasach
    // afterValidation(callback) {
    //     this.externalValidatorHandlers.push(callback);
    // }

    emitAfterSaveHandler() {
        this.afterChangeHandlers.forEach(callback => {
            try {
                callback()
            } catch (e) {
                Log.fatal(e, true);
            }
        });
    }

    // TODO odświeżanie zakładek na watch klasach
    // emitExternalValidations() {
    //     this.externalValidatorHandlers.forEach(callback => {
    //         try {
    //             callback()
    //         } catch (e) {
    //             Log.fatal(e, true);
    //         }
    //     });
    // }


    /**
     *
     * @param {FormModel} extFormModel
     */
    registerChildExtensionModel(extFormModel) {
        if (extFormModel.formConfig.isExtension) {
            if (extFormModel.extensionConfig.name) {
                extFormModel.onChangePreValidate(() => this.emitOnChangePreValidate());
                this.extensionModels.set(extFormModel.extensionConfig.name, extFormModel);
            }
        }
    }

    /**
     *
     * @param fieldName {string}
     * @param validatedField {FormValidatedField}
     */
    connectFilterDetail(fieldName, validatedField) {
        // find detail
        for (const dc of this.formConfig.details) {
            if (dc.templateFilterBy === fieldName) {
                this.connectFilterToDeTail(fieldName, validatedField, dc);
            }
        }
    }

    /**
     *
     * @param fieldName {string}
     * @param validatedField {FormValidatedField}
     * @param detailConf {FormDetailsConfig}
     */
    connectFilterToDeTail(fieldName, validatedField, detailConf) {
        if (!this.fieldToDetails.has(fieldName)) {
            this.fieldToDetails.set(fieldName, []);
        }
        this.fieldToDetails.get(fieldName).push({fieldName, validatedField, detailConf});

        validatedField.onChangeDelayed(() => {
            let newVal = JSON.stringify(validatedField.value);
            let detailForm = FormsLoader.detectFormConfig(detailConf.detailsClass);
            if (this.fieldToDetailsValues.get(fieldName) !== newVal) {
                if (this.fieldToDetailsValues.get(fieldName) != null) {
                    if (!this.detailsNotifications.has(fieldName)) {

                        DialogManager.info("Complex change", `Changing ${validatedField.formFieldConfig.fieldLabel} may change ${detailForm.entityPlural}`).then();
                        this.detailsNotifications.add(fieldName);
                    }
                }

                this.fieldToDetailsValues.set(fieldName, newVal);
                if (this.mode === 'NEW') {

                    this.originalSource[fieldName] = validatedField.value;
                    // console.log(`Reloading ${detailForm.entityPlural}`)
                    this.detailReloadCallback(this.originalSource, fieldName, validatedField, detailConf);
                }
            }
        });
    }

    resetDetailsFilterInfo() {
        for (let [k, listOFDetails] of this.fieldToDetails) {
            for (let {fieldName, validatedField, detailConf} of listOFDetails) {
                let fld = this.validatedFieldsByName.get(fieldName);
                if (fld === undefined) {
                    // console.log(`no field found ${fieldName}`)
                }

                this.fieldToDetailsValues.set(fieldName, fld.value);
            }
        }
    }

    /**
     * @param {FormValidatedField} validatedField
     */
    async reloadJoinedFields(validatedField) {
        // for(const k of this.formConfig.fieldDependencies[validatedField.formFieldConfig.fieldName]){
        //     this.fields[k].value = null;
        // }
        if (this.fakeModel) {
            return;
        }

        const val = validatedField.value;
        let deps = await Rpc.Forms.refreshJoinedFields(this.formConfig.formClassLong, validatedField.formFieldConfig.fieldName, validatedField.value);

        if (val === validatedField.value) {
            for (const k in deps) {
                try {
                    const newVal = deps[k];

                    if (this.fields[k]) {
                        let changed = JSON.stringify(this.fields[k].value) !== JSON.stringify(newVal);

                        this.fields[k].value = newVal;
                        if (changed && this.fields[k].formFieldConfig.freezeOnField) {
                            this.fields[this.fields[k].formFieldConfig.freezeOnField].value = newVal;
                        }
                    } else { // shadow
                        let changed = JSON.stringify(this.originalSource[k]) !== JSON.stringify(newVal);
                        let fieldConf = this.formConfig.fields.find(fld => fld.fieldName === k);
                        if (changed && fieldConf.freezeOnField) {
                            this.originalSource[k] = newVal;
                            this.fields[fieldConf.freezeOnField].value = newVal;
                        }
                    }
                } catch (e) {
                    let x = 5;
                    Log.fatal(e);
                }
            }
        }
        await this.refreshComputedValidatedFields();
    }

    updateMasterState() {
        if (this.masterFormModel) {
            this.masterFormModel.updateMasterState();
        } else {
            this.emitOnChange();
        }
    }

    setContextData(data) {
        this.contextData = data ?? {};
    }

    addValidatedField(name, validatedField) {
        this.validatedFields.push(validatedField);
        this.validatedFieldsByName.set(name, validatedField);
        this.fields[name] = validatedField;
    }

    refreshValidationState() {
        super.refreshValidationState();
        this.refreshAfterSavedStatus();
    }

    refreshAfterSavedStatus() {
        if (this.afterSaveChecksum !== this.calcChecksum()) {
            if (this.afterSaveStatus === "NEW") {
                this.currentAfterSaveStatus = "NEW"
            } else {
                let hasErrorsInLists = false;
                for (let list in this.temporaryLists) {
                    if (this.temporaryLists[list].afterSaveStatus === "ERROR") {
                        hasErrorsInLists = true;
                        break;
                    }
                }
                for (let item in this.temporaryExtensions) {
                    if (this.temporaryExtensions[item].afterSaveStatus === "ERROR") {
                        hasErrorsInLists = true;
                        break;
                    }
                }

                if (hasErrorsInLists) {
                    this.currentAfterSaveStatus = "ERROR";
                } else {
                    this.currentAfterSaveStatus = "EDITED";
                }
            }
        } else {
            if (this.afterSaveStatus === "NEW") {
                this.currentAfterSaveStatus = "NEW"
            } else {
                let hasErrorsInLists = false;
                let hasEditedInLists = false;

                for (let list in this.temporaryLists) {
                    if (this.temporaryLists[list].afterSaveStatus === "EDITED") {
                        hasEditedInLists = true;
                    }
                    if (this.temporaryLists[list].afterSaveStatus === "ERROR") {
                        hasErrorsInLists = true;
                        break;
                    }
                }

                for (let item in this.temporaryExtensions) {
                    if (this.temporaryExtensions[item].afterSaveStatus === "EDITED") {
                        hasEditedInLists = true;
                    }
                    if (this.temporaryExtensions[item].afterSaveStatus === "ERROR") {
                        hasErrorsInLists = true;
                        break;
                    }
                }

                if (hasErrorsInLists) {
                    this.currentAfterSaveStatus = "ERROR";
                } else {
                    this.currentAfterSaveStatus = this.afterSaveStatus;
                }
            }
        }

        if (this.masterTemporaryList) {
            this.masterTemporaryList.refreshAfterSavedStatus();
        }
        if (this.masterTemporaryExtension) {
            this.masterTemporaryExtension.refreshAfterSavedStatus();
        }

    }

    isAutoSave(fieldName, validatedField) {
        return validatedField.formFieldConfig?.autosave;
    }

    /**
     * @param {FormDetailsConfig|FormExtensionConfig} field
     * @return {string}
     */
    makeFieldKey(field) {
        return (field.detailsClass ?? field.extensionClass) + ":" + field.joiningField;
    }

    /**
     * @return {*}
     */
    collectUniqueFields() {
        let source = this._newInstance();
        this._forEachValidatedField((fieldName, validatedField) => {
            if (validatedField.formFieldConfig.inUniqueConstraint) {
                source[validatedField.formFieldConfig.fieldName] = validatedField.value ?? null;
            }
        });

        this.formConfig.shadowFields.forEach((field) => {
            if (field.inUniqueConstraint && !source[field.fieldName]) {
                source[field.fieldName] = this.originalSource[field.fieldName] ?? null;
            }
        });

        source['id'] = this.originalSource?.id ?? null;
        return source;
    }

    collectAllEmbeddedInstances(embeddedClazz, excludeModel, result = null) {
        if (result === null) {
            result = [];
        }
        if (this.formConfig?.formClassLong === embeddedClazz) {
            if (excludeModel !== this) {
                this.collectInputs();
                result.push(this.originalSource);
            }
        } else {
            this._forEachValidatedField((name, field) => {
                if (field.__subItems__) {
                    field.__subItems__.forEach(subForm => {
                        if (!subForm?.form?.collectAllEmbeddedInstances) {
                            // console.log("Strange");
                        }
                        subForm?.form?.collectAllEmbeddedInstances(embeddedClazz, excludeModel, result);
                    })
                }
            });
        }
        if (this.childrenFormModels) {
            for (const [k, tabForm] of Object.entries(this.childrenFormModels)) {
                tabForm?.collectAllEmbeddedInstances(embeddedClazz, excludeModel, result);
            }
        }
        return result;
    }

    async checkUnique() {
        if (this.fakeModel) {
            return;
        }

        if (this.uniqCheckInProgress) {
            return this.uniqCheckPromise;
        }
        this.uniqCheckInProgress = true;

        this.uniqCheckPromise = new Promise((resolve, reject) => {
            this.promiseResolve = resolve;
            this.promiseReject = reject;
        });

        let featureFlags = this.extensionConfig?.enabledByFeatureFlags;
        let enabledFormByFeatureFlags = true;
        if (featureFlags?.length) {
            enabledFormByFeatureFlags = checkIfEnabledByFeatureFlags(featureFlags);
        }

        let checkUntil = () => {
            if (!enabledFormByFeatureFlags) {
                return;
            }
            let state = this.collectUniqueFields();
            this.checkingUniq = stringifyForCompare(state); // TODO

            let siblings = null;
            if (this.directParentFormModel) {
                siblings = this.masterFormModel?.collectAllEmbeddedInstances(this.formConfig.formClassLong, this) ?? [];
            }
            if (state['id'] === "undefined") {
                state = this.collectUniqueFields();
            }

            if (!this.formConfig.isView) {
                // sprawdzić czy temporary Lista
                Rpc.Forms.checkConstraints(this.formConfig.formClassLong, state,
                    this.directParentFormModel?.formConfig?.formClassLong,
                    this.directParentFormModel?.originalSource?.id, siblings).then(res => {
                    let newState = this.collectUniqueFields();
                    if (stringifyForCompare(newState) === this.checkingUniq) { // TODO
                        let resolver = this.promiseResolve;
                        this.checkingUniq = "";
                        this.uniqCheckInProgress = false;
                        this.uniqCheckPromise = null;
                        this.promiseResolve = null;
                        this.promiseReject = null;
                        resolver(res);
                    } else {
                        checkUntil();
                    }
                }).catch(e => {
                    let resolver = this.promiseReject;
                    this.checkingUniq = "";
                    this.uniqCheckInProgress = false;
                    this.uniqCheckPromise = null;
                    this.promiseResolve = null;
                    this.promiseReject = null;
                    // console.log("After:");
                    // console.log(state);
                    resolver?.(e);
                });
            }
        }
        checkUntil();
        return this.uniqCheckPromise;
    }

    async refreshVisibilityOfReadOnly() {
        let promises = this._forEachValidatedField((name, f) => {
            return f.checkVisibility();
        });
        await Promise.all(promises);
    }

    setFieldsReadOnly(val, mode, fieldsConfigByParent) {
        this._forEachValidatedField((name, f) => {
            let parentConf = null;
            if (fieldsConfigByParent && fieldsConfigByParent[name]) {
                parentConf = fieldsConfigByParent[name];
            }
            if (f.formFieldConfig.securedFieldConfig) {
                if (!f.formFieldConfig.securedFieldConfig.restrictedWrite) {
                    f.readOnly = val;
                } else {
                    if (val) {
                        f.readOnly = val;
                    } else {
                        f.readOnly = !this.permissions[f.formFieldConfig.securedFieldConfig.effectivePermissionWrite]
                    }
                }
                return;
            }

            if (f.formFieldConfig.readOnly || parentConf?.readOnly) {
                f.readOnly = true;
                return;
            }

            if (mode === "EDIT" && (f.formFieldConfig.readOnlyInEdit || parentConf?.readOnlyInEdit)) {
                f.readOnly = true;
                return;
            }

            f.readOnly = val;
        });
    }

    /**
     * @param {function(string, FormValidatedField)} callback
     */
    _forEachValidatedField(callback) {
        let results = [];
        this.validatedFields.forEach(f => {
            try {
                results.push(callback(f.formFieldConfig.fieldName, f))
            } catch (e) {
                throw e;
            }
        })
        return results;
    }

    hasValidatedFieldByName(name) {
        return this.validatedFieldsByName.has(name);
    }

    /**
     * @param name
     * @return {FormValidatedField}
     */
    validatedFieldByName(name) {
        return this.validatedFieldsByName.get(name);
    }

    field(name) {
        return this.validatedFieldByName(name);
    }

    /**
     * @param name
     * @return {FormValidatedField}
     */
    hiddenFieldByName(name) {
        return this.shadowFields.get(name);
    }

    async loadEntityAsExtension(baseEntityId) {

        let baseClass = this.extensionConfig.baseClass;
        let field = this.extensionConfig.joiningField;

        let entity = await Rpc.Forms.getExtendedEntityExtension(baseClass, baseEntityId, field, this.extensionConfig.extensionClass).lock();

        if (entity == null) {
            // if(this.formConfig.extensions){
            //     this.formConfig.extensions.forEach(detail =>
            //         this.temporaryExtensions[this.makeFieldKey(detail)] = new TemporaryExtension(detail, this));
            // }
        } else {
            super.editMode(entity);
            this.resetDetailsFilterInfo();
            return entity;
        }
    }

    async loadEntity(entityId) {
        let entity;
        if (this.formConfig.isDynamic) {
            entity = await Rpc.Forms.getExtendedDynamicEntity(this.formConfig.formClassLong, entityId).lock();
        } else {
            entity = await Rpc.Forms.getExtendedEntity(this.formConfig.formClassLong, entityId).lock();
        }
        super.editMode(entity);
        this.resetDetailsFilterInfo();
        return entity;
    }

    collectInputs() {
        if (this.originalSource) {
            this.populateValuesTo(this.originalSource);
        }
        this.extensionModels?.forEach(model => model.collectInputs());
    }

    getExtensionsObjectsForExpression() {
        let res = {};
        this.extensionModels?.forEach((model, name) => {
            const key = '$' + name;
            res[key] = {...model.originalSource, ...model.getExtensionsObjectsForExpression()};
        });

        return res;
    }

    /**
     * @param target
     * @return {*}
     */
    populateValuesTo(target, isDynamic = false) {
        let tg = target;
        this._forEachValidatedField((name, field) => {
            if (name === '_translations') {
                return;
            }
            if (!field.formFieldConfig.computed) {
                if (target.hasOwnProperty(name) || isDynamic) {
                    target[name] = field.baseValue;
                }
                if ((field.formFieldConfig.translations || field.formFieldConfig.interfaceTranslation) && field.translations) {
                    if (!target._translations) {
                        target._translations = {};
                    }
                    for (let lang in field.translations) {
                        if (!target._translations[lang]) {
                            target._translations[lang] = {};
                        }
                        target._translations[lang][field.formFieldConfig.fieldName] = field.translations[lang];
                    }
                    let langInDb = detectDBLanguage(field);
                    let langInTyping = detectInputTypingLanguage(field);
                    field.translations[langInTyping] = target[name];
                    if (langInDb !== langInTyping) {
                        target[name] = field.translations[langInDb];
                    }
                }
            }
        });

        return target;
    }

    flatTranslations(translations, fieldConfig) {
        return flatTranslationsBeforeRecordSave(translations, fieldConfig);
    }

    async saveEditedToDb(currentRegion) {


        this.populateValuesTo(this.originalSource, this.formConfig.isDynamic);

        this._forEachValidatedField((name, field) => {
            this.flatTranslations(field.translations, field);
        });

        let res;
        if (this.formConfig.isDynamic) {
            res = await Rpc.Forms.mergingEditDynamicEntity(this.formConfig.formClassLong, this.originalSource, this.originalSource?.recordMetadata?.versionTag).lock().tag(this.tag);
        } else {
            if (this.originalSource?.recordMetadata?.versionTag) {
                this.originalSource.currentSelectedRegion = currentRegion;
                res = await Rpc.Forms.mergingEditEntity(this.formConfig.formClassLong, this.originalSource, this.originalSource?.recordMetadata?.versionTag).lock().tag(this.tag);
            } else {
                res = await Rpc.Forms.editEntity(this.formConfig.formClassLong, this.originalSource).lock().tag(this.tag);
            }
        }
        if (res) {
            this.editMode(res);
            this.resetChecksum();
            this.emitAfterSaveHandler();
            return res;
        }
        this.editMode(this.originalSource);
        this.resetChecksum();
        return this.originalSource;
    }

    async saveEditedToTmpList() {
        this.resetChecksum();
        return this.originalSource;
    }

    isDetailVisible(detailName) {
        let detailConf = this.formConfig.details.find(det => det.name === detailName);
        if (!detailConf.enabledByFeatureFlags?.length) {
            if (!detailConf?.visibleFunction) {
                return true;
            }
            return RtModule()[detailConf.visibleFunction].call(this.originalSource, this, this.masterFormConfig, this.directParentFormModel);
        }
        let enabledForm = checkIfEnabledByFeatureFlags(detailConf.enabledByFeatureFlags);
        if (!enabledForm) {
            return false;
        }
        if (!detailConf?.visibleFunction) {
            return true;
        }
        return RtModule()[detailConf.visibleFunction].call(this.originalSource, this, this.masterFormConfig, this.directParentFormModel);
    }

    isExtensionVisible(extName) {
        let extConf = this.formConfig.extensions.find(ext => ext.name === extName);
        if (!extConf.enabledByFeatureFlags?.length) { // null || []
            if (!extConf?.visibleFunction) {
                return true;
            }
            return RtModule()[extConf.visibleFunction].call(this.originalSource, this.originalSource, this, this.masterFormConfig, this.directParentFormModel);
        }
        let enabledForm = checkIfEnabledByFeatureFlags(extConf.enabledByFeatureFlags);
        if (!enabledForm) {
            return false;
        }
        if (!extConf?.visibleFunction) {
            return true;
        }
        // instance, formConfig, masterFormConfig, parentFormConfig, specialVars
        return RtModule()[extConf.visibleFunction].call(this.originalSource, this.originalSource, this, this.masterFormConfig, this.directParentFormModel);
    }

    toComplexNewRecord() {
        if (!this.originalSource.__id__) {
            this.originalSource.__id__ = temporaryId--;
        }
        this.populateValuesTo(this.originalSource);

        let complexRecord = new ComplexNewRecord();
        complexRecord.clazz = this.formConfig.formClassLong;
        complexRecord.tmpId = this.originalSource.__id__;
        complexRecord.instance = this.originalSource;
        complexRecord.idToInjectIntoField = null;
        complexRecord.details = [];
        complexRecord.extensions = [];

        for (const fieldKey in this.temporaryLists) {
            const tmpList = this.temporaryLists[fieldKey];

            if (this.isDetailVisible(tmpList.formDetailsConfig.name)) {
                complexRecord.details.push(tmpList.collectAll(complexRecord.tmpId));
            }
        }

        // for (const fieldKey in this.temporaryExtensions) {
        //     const tmpInst = this.temporaryExtensions[fieldKey];
        //     if (this.isExtensionVisible(tmpInst.formExtensionConfig.name)) {
        //         complexRecord.extensions.push(tmpInst.collect(complexRecord.tmpId));
        // }
        // }
        this.afterSaveChecksum = this.initialChecksum;
        return complexRecord;
    }

    /**
     * @return {Promise<*>}
     */
    async saveComplex() {
        const record = this.toComplexNewRecord();
        /** @type {ComplexNewRecordError} */
        let res = await Rpc.Forms.addComplexEntity(this.formConfig.formClassLong, record).lock().tag(this.tag);
        this.populateErrors(res.virtualIdToValidations);
        this.originalSource = this.populateIds(res.virtualIdToId);
        this.resetChecksum();
        // this.emitAfterSaveHandler();

        // if (res.allValid) {
        //     return res.primaryInstance;
        // }
        return this.originalSource;
    }

    populateIds(vIdToId) {
        for (const fieldKey in this.temporaryLists) {
            const tmpList = this.temporaryLists[fieldKey];
            tmpList.populateIds(vIdToId);
        }

        for (let item in this.temporaryExtensions) {
            this.temporaryExtensions[item].populateIds(vIdToId);
        }
        this.originalSource.id = vIdToId[this.originalSource.__id__];
        this.resetChecksum();
        return this.originalSource;
    }

    populateErrors(virtualIdToValidations) {
        if (virtualIdToValidations.hasOwnProperty(this.originalSource.__id__)) {
            this.isValid = false;
            const validationResult = virtualIdToValidations[this.originalSource.__id__];
            this.parseException(validationResult);
        } else {
            this.isValid = true;
        }
        this.temporaryListsErrors = false;
        for (const fieldKey in this.temporaryLists) {
            const tmpList = this.temporaryLists[fieldKey];
            tmpList.populateErrors(virtualIdToValidations);
            if (tmpList.hasErrors) {
                this.temporaryListsErrors = true;
            }
        }
        this.afterSaveStatus = this.isValid ? "VALID" : "ERROR";
        this.currentAfterSaveStatus = (!this.temporaryListsErrors && this.isValid) ? "VALID" : "ERROR";
    }

    async saveNewToDb() {
        if (this.temporaryLists || this.temporaryExtensions) {
            return this.saveComplex();
        }
        let res = await Rpc.Forms.addEntity(this.formConfig.formClassLong, this.originalSource).lock().tag(this.tag);

        this.resetChecksum();
        if (res) {
            this.originalSource = res;
            // this.editMode(res);
            // this.resetChecksum();
            // this.emitAfterSaveHandler();
            // return res;
        }
        return this.originalSource;
    }

    markAsEdited() {
        this.afterSaveStatus = "EDIT";
        if (this.masterTemporaryList) {
            this.masterTemporaryList.formModel.markAsEdited();
        }
    }

    async saveNewToTmpList() {
        // null instance
        if (this.originalSource instanceof ApplicationUserOnProductInSeason) {
            this.originalSource.productInSeasonId = null;
        }
        this.afterSaveStatus = "NEW";
        this.originalSource.__id__ = temporaryId--;
        this.originalSource.__formModel__ = this;
        this.masterTemporaryList.push(this.originalSource);
        this.editMode(this.originalSource);
        this.resetChecksum();
        this.markAsEdited();

        return this.originalSource;
    }

    async saveEntity(forceTmpToDb = false, currentRegion) {
        try {
            Log.trace(`Saving ${this.formConfig.formClass}...`);
            //this.field.translations
            await fillMissingTranslationsBeforeSaveToDb(this);
            this.populateValuesTo(this.originalSource);
            let promises = [];
            this._forEachValidatedField((name, field) => {
                let promise = field.waitForDelayedUpdates();
                if (promise) {
                    promises.push(promise);
                }
            });
            await Promise.all(promises);

            if ((forceTmpToDb || !this.masterTemporaryList) && this.originalSource.id != null) {
                return this.saveEditedToDb(currentRegion);
            }
            if (forceTmpToDb || !this.masterTemporaryList) {
                return this.saveNewToDb();
            }
            if (this.masterTemporaryList && this.originalSource.__id__ != null) {
                return this.saveEditedToTmpList();
            }
            return this.saveNewToTmpList();
        } catch (e) {
            if (e instanceof RpcInputValidationException) {
                this.parseException(e);
            }
            throw e;
        } finally {
            Log.trace(`${this.formConfig.formClass} saved`);
        }

    }

    _newInstance() {
        let clazz = RpcClass;
        if (this.formConfig.formClass && classMap.hasOwnProperty(this.formConfig.formClassLong)) {
            clazz = classMap[this.formConfig.formClassLong];
        }
        return new clazz();
    }

    newEntitySync() {
        Promise.all(this._newEntity()).then();
        return this.originalSource;
    }

    async newEntity(initializer = null) {
        await Promise.all(this._newEntity(initializer));
        if (!this.formConfig.isDynamic) {
            this.originalSource = await Rpc.Forms.initializeNewRecord(this.formConfig.formClassLong, this.originalSource);
        }
        return this.originalSource;
    }

    _newEntity(initializer = null) {
        let allPromises = [];

        this.originalSource = this._newInstance();
        this.originalSource.__form_id__ = this.formConfig.formId;

        this.formConfig.fields.forEach(f => {
            if (!f.computed) {
                if (f.defaultValue) {
                    this.originalSource[f.fieldName] = yaml.load(f.defaultValue);
                } else {
                    this.originalSource[f.fieldName] = null;
                }
            }
        });
        if (initializer) {
            initializer(this.originalSource);
        }
        this.formConfig.shadowFields.forEach(f => {
            if (this.originalSource[f.fieldName] == null) {
                if (f.defaultValue) {
                    this.originalSource[f.fieldName] = yaml.load(f.defaultValue);
                } else {
                    this.originalSource[f.fieldName] = null;
                }
            }
        });
        if (this.formConfig.attachments) {
            this.originalSource.attachments = [];
        }

        if (this.masterFormConfig && this.detailsConfig) {
            this.originalSource[this.detailsConfig.joiningField] = this.masterId;
        }
        if (this.masterFormConfig && this.extensionConfig) {
            this.originalSource[this.extensionConfig.joiningField] = this.masterId;

            // this.afterSaveStatus = "NEW";
            this.originalSource.__id__ = temporaryId--;
            this.originalSource.__formModel__ = this;
            this.masterTemporaryExtension.set(this.originalSource);
            this.editMode(this.originalSource, "NEW");
            this.resetChecksum();
            //this.markAsEdited();
        }

        if (this.presetFields) {
            for (let field of this.presetFields) {
                if (field.className && field.className !== this.formConfig.formClassLong) {
                    continue;
                }

                let fieldName = field.fieldName;
                let fld = this.validatedFieldByName(fieldName);
                if (fld) {
                    this.originalSource[fieldName] = field.value;
                    fld.foreignValueLabel = field.foreignValueLabel;
                    fld.foreignValueInstance = field.foreignValueInstance;
                }
            }
        }

        super.createMode(this.originalSource);

        if (this.formConfig.details) {
            this.formConfig.details.forEach(detail => {
                const tmpList = new TemporaryList(detail, this);
                this.temporaryLists[this.makeFieldKey(detail)] = tmpList;
                let masterRaw = this.originalSource;
                // if(detail.hasInitialFactory){
                //     allPromises.push(
                //         Rpc.Forms.getDetails(this.formConfig.formClassLong, detail.detailsClass, masterRaw).then(data => {
                //           this.fillInitialDetails(detail, data, tmpList);
                //         })
                //     );
                // }
            });
        }
        if (this.formConfig.extensions) {
            this.formConfig.extensions.forEach(detail => {
                this.temporaryExtensions[this.makeFieldKey(detail)] = new TemporaryExtension(detail, this);
            });
        }

        setTimeout(() => {
            this.resetChecksum();
        });

        this.refreshComputedValidatedFields()
        return allPromises;
    }

    /**
     * @param masterInstance {RpcClass}
     * @param fieldName {string}
     * @param validatedField {FormValidatedField}
     * @param detailConf {FormDetailsConfig}
     */
    async reloadDetail(masterInstance, fieldName, validatedField, detailConf) {
        let tmpList = this.temporaryLists[this.makeFieldKey(detailConf)];
        if (!tmpList) {
            return;
        }
        let data = await Rpc.Forms.getDetails(this.formConfig.formClassLong, detailConf.detailsClass, masterInstance);
        this.fillInitialDetails(detailConf, data, tmpList);
    }

    /**
     * @param {RpcInputValidationException|RpcException} validationException
     */
    parseException(validationException) {
        this.saveError = "";

        if (validationException instanceof RpcInputValidationException || validationException instanceof InputValidationResult) {
            for (let f in (validationException.fields || validationException.fieldsValidationResults)) {
                if (this.validatedFieldsByName.has(f)) {
                    this.validatedFieldsByName.get(f).parseException((validationException.fields || validationException.fieldsValidationResults)[f]);
                    if (!this.validatedFieldsByName.get(f).isValid) {
                        this.saveError +=
                            _.escape(this.validatedFieldsByName.get(f).label + ": " + this.validatedFieldsByName.get(f).errorMessage) + "<br>";
                    }
                } else {
                    Log.info("Field '" + f + "' not found in form");
                }
            }
            this.generalFeedback = validationException.errorMessage;
        } else {
            this.generalFeedback = $tr('formModel.server.error', 'Server error - please try again in few minutes');
        }
        if (this.generalFeedback) {
            this.saveError = _.escape(this.generalFeedback) + "<br><br>" + this.saveError;
        }
    }

    /**
     * @param detail {FormDetailsConfig}
     * @param data {BusinessRecord[]}
     * @param tmpList {TemporaryList}
     */
    fillInitialDetails(detail, data, tmpList) {
        if (data !== null) {
            let currentIds = new Set();
            let newIds = new Set();

            for (let el of tmpList.items) {
                currentIds.add(el[detail.templateToDetailJoinField]);
            }

            data.forEach(element => {
                let formConfig = FormsLoader.detectFormConfig(element);
                newIds.add(element[detail.templateToDetailJoinField]);

                if (!currentIds.has(element[detail.templateToDetailJoinField])) {
                    if (detail.factoryType === "Template") {
                        for (const f of formConfig.fields) {
                            if (f.formDisabled) {
                                continue;
                            }
                            if (f.defaultValue !== null) {
                                element[f.fieldName] = yaml.load(f.defaultValue);
                            }
                        }
                    }
                    let form = new FormModel(formConfig, this.presetFields);
                    form.masterTemporaryList = tmpList;

                    form.editMode(element);

                    form.afterSaveStatus = "NEW";
                    form.originalSource.__id__ = temporaryId--;
                    form.originalSource.__formModel__ = form;
                    form.masterTemporaryList.push(form.originalSource);
                    form.resetChecksum();
                    form.markAsEdited();
                }
            });

            for (let i = 0; i < tmpList.items.length; i++) {
                let item = tmpList.items[i];
                if (!newIds.has(item[detail.templateToDetailJoinField])) {
                    tmpList.items.splice(i, 1);
                    i--;
                }
            }
        }
    }

    async refreshComputedValidatedFields(skipFrozenField) {
        if (this.fakeModel) {
            return;
        }

        if (this.refreshComputedScheduled) {
            this.skipFrozenField = skipFrozenField && this.skipFrozenField;
            return;
        }
        this.skipFrozenField = skipFrozenField;
        this.refreshComputedScheduled = true;
        setTimeout(async () => {
            this.refreshComputedScheduled = false;
            if (this.originalSource?.refreshComputed) {
                this.collectInputs();
                let oldValues = {};
                for (let f of this.formConfig.fields) {
                    if (f.computed) {
                        oldValues[f.fieldName] = this.originalSource[f.fieldName];
                    }
                }


                if (!this._computeFieldStartTimes) {
                    this._computeFieldStartTimes = {};
                }

                this.formConfig.fields
                    .filter(f => f.computed)
                    .forEach(f => {
                        const vf = this.validatedFieldByName(f.fieldName);
                        if (vf) {
                            vf.computeFieldInProgress = true;
                            this._computeFieldStartTimes[f.fieldName] = Date.now();
                        }
                    });

                if (!this.formConfig.isDynamic) {
                    await this.originalSource.refreshComputed(this.formConfig, this.regionCode);
                }
                if (!this.readOnlyMode) {
                    this._forEachValidatedField((name, f) => {
                        f.checkVisibility();
                    });
                }
                for (let f of this.formConfig.fields) {
                    if (f.computed) {
                        if (this.validatedFieldByName(f.fieldName)) {
                            this.validatedFieldByName(f.fieldName).value = this.originalSource[f.fieldName];
                        }
                        const fieldConf = f;
                        if (fieldConf.freezeOnField) {
                            if (this.skipFrozenField) {
                                continue;
                            }
                            const newComputedVal = this.originalSource[fieldConf.fieldName];
                            const oldComputedVal = oldValues[fieldConf.fieldName];
                            const oldFrozenVal = this.originalSource[fieldConf.freezeOnField];
                            const newFrozenVal = newComputedVal;
                            // jeżeli ktoś zmienił ręcznie (wpisał wartość niepustą) - to nie chcemy nadpisywać tego co zmienił, dlatego jest continue
                            if (JSON.stringify(oldComputedVal) !== JSON.stringify(oldFrozenVal) && fieldConf.freezeLockedUpdateOnUserEdit) {
                                continue;
                            }
                            if (JSON.stringify(oldComputedVal) === JSON.stringify(newComputedVal) && !fieldConf.freezeLockedUpdateOnUserEdit) {
                                continue;
                            }
                            if (JSON.stringify(oldComputedVal) === JSON.stringify(oldFrozenVal) && oldComputedVal?.decimal === null
                                && oldFrozenVal?.decimal === null) {
                                continue;
                            }
                            if (JSON.stringify(oldComputedVal) === JSON.stringify(oldFrozenVal) && oldComputedVal?.decimal !== null
                                && oldFrozenVal?.decimal !== null && oldComputedVal?.decimal?.compareTo(new BigDecimal(0)) === 0
                                && oldFrozenVal?.decimal?.compareTo(new BigDecimal(0)) === 0) {
                                continue;
                            }
                            if (JSON.stringify(newComputedVal) !== JSON.stringify(oldFrozenVal)) {
                                this.originalSource[fieldConf.freezeOnField] = newComputedVal;
                                if (this.fields[fieldConf.freezeOnField]) {
                                    this.fields[fieldConf.freezeOnField].value = newComputedVal;
                                }
                            }
                        }
                    }
                }
                this.formConfig.fields
                    .filter(f => f.computed)
                    .forEach(f => {
                        const vf = this.validatedFieldByName(f.fieldName);
                        if (vf) {
                            vf.computeFieldInProgress = false;
                            const start = this._computeFieldStartTimes[f.fieldName];
                            if (start) {
                                const durationMs = Date.now() - start;
                                // debug mode
                                // console.log(`Computed field ${f.fieldName} took ${durationMs / 1000} seconds`);
                            }
                        }
                    });
            }
        })

    }

    setupShadowFieldsObservers() {
        const formConfig = this.formConfig;

        for (const f of formConfig.shadowFields) {
            if (f.fieldName === "recordMetadata") {
                continue;
            }
            let initial = f.defaultValue !== null ? yaml.load(f.defaultValue) : null;
            let validatedField = new FormValidatedField(f, this, initial);
            validatedField.label = f.fieldLabel;
            this.addValidatedField(f.fieldName, validatedField);
            if (this.formConfig.fieldDependencies?.hasOwnProperty(f.fieldName)) {
                validatedField.onChange(() => {
                    this.reloadJoinedFields(validatedField).then();
                });
            }
        }
    }

    setupFieldsObservers() {
        const formConfig = this.formConfig;
        let hasComputed = false;
        for (let f of this.formConfig.fields) {
            if (f.computed) {
                hasComputed = true;
                break;
            }
        }
        for (const f of formConfig.fields) {
            if (f.formDisabled) {
                continue;
            }
            let initial = f.defaultValue !== null ? yaml.load(f.defaultValue) : null;
            let validatedField = new FormValidatedField(f, this, initial);
            validatedField.label = f.fieldLabel;
            this.addValidatedField(f.fieldName, validatedField);

            if (this.formConfig.detailsFilteringFields) {
                if (this.formConfig.detailsFilteringFields.includes(validatedField.formFieldConfig.fieldName)) {
                    this.connectFilterDetail(validatedField.formFieldConfig.fieldName, validatedField);
                }
            }

            if (this.formConfig.fieldDependencies?.hasOwnProperty(f.fieldName)) {
                validatedField.onChange(() => {
                    this.reloadJoinedFields(validatedField).then();
                });
            }

            if (!validatedField.formFieldConfig.computed) {
                validatedField.onChangeDelayed(() => {
                    this.refreshComputedValidatedFields().then();
                });
            }
        }
    }

    /**
     * @param vueComponent {Vue}
     */
    setupWatchers(vueComponent) {
        if (this.formConfig?.watchedClasses) {
            for (let watchedType of this.formConfig.watchedClasses) {
                vueComponent.$onChange(watchedType.className, async () => {
                    await this.refreshComputedValidatedFields();
                });
                // TODO odświeżanie zakładek na watch klasach
                // this.emitExternalValidations();
            }
        }
    }

    canDelete() {
        return this.originalSource?.__supplement__?.canDelete == null;
    }

    canEdit() {
        if (!this.formConfig.editableForm) {
            return false;
        }

        let editEnabledBySecuredFields = findEditEnabledFormBySecuredFields(this.formConfig, this.permissions);
        return this.originalSource?.__supplement__?.editable !== false &&
            (!this.restrictedWrite || SessionManager.hasPermission(this.effectivePermissionWrite) || editEnabledBySecuredFields);
    }
}